import React, { Dispatch, SetStateAction, useState } from 'react';
import {
  View, Text, Pressable, StyleSheet,
  ScrollView,
} from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import Style from '../../../../../constants/Style';
import {
  AssetSortCategory, AssetSortCategoryTitles,
} from '../../../../../requests/Assets/GetAssets';
import Colors from '../../../../../constants/Colors';
import { PressableState } from '../../../../../components/PressableStyled';

interface AssetSortSelectionProps {
  selectedSortCategory: AssetSortCategory,
  setSelectedSortCategory: Dispatch<SetStateAction<AssetSortCategory>>,
  sortDescending: boolean,
  setSortDescending: Dispatch<SetStateAction<boolean>>,
}

const AssetSortSelection = ({
  selectedSortCategory, setSelectedSortCategory, sortDescending, setSortDescending,
}: AssetSortSelectionProps) => {
  const [categoryDropdownToggled, setCategoryDropdownToggled] = useState<boolean>(false);
  const [orderDropdownToggled, setOrderDropdownToggled] = useState<boolean>(false);

  return <View style={styles.container}>
    <View style={{ flex: 1 }}>
      <Pressable
        style={styles.dropdownButton}
        onPress={() => setCategoryDropdownToggled(!categoryDropdownToggled)}
      >
        <Text style={Style.dropdownText}>
          {selectedSortCategory ? AssetSortCategoryTitles[selectedSortCategory] : 'Select category'}
        </Text>
        <FontAwesome
          name={categoryDropdownToggled ? 'angle-up' : 'angle-down'}
          size={24}
          color={Colors.light.hereworksBlue500}
        />
      </Pressable>
      <View>
        {categoryDropdownToggled && <ScrollView style={styles.dropdownContent}>
          {Object.values(AssetSortCategory).map((item: AssetSortCategory) => <Pressable
            style={({ hovered, pressed }: PressableState) => [
              styles.menuItem,
              hovered && Style.listItemHovered, pressed && Style.listItemPressed,
            ]}
            onPress={() => {
              setSelectedSortCategory(item);
              setCategoryDropdownToggled(false);
            }}
            key={`category_${item}`}
          >
            <Text style={Style.dropdownText}>{AssetSortCategoryTitles[item]}</Text>
          </Pressable>)}
        </ScrollView>}
      </View>
    </View>
    <View style={{ flex: 1, marginStart: 8 }}>
      <Pressable
        style={styles.dropdownButton}
        onPress={() => setOrderDropdownToggled(!orderDropdownToggled)}
      >
        <Text style={Style.dropdownText}>
          {sortDescending ? 'Descending' : 'Ascending'}
        </Text>
        <FontAwesome
          name={orderDropdownToggled ? 'angle-up' : 'angle-down'}
          size={24}
          color={Colors.light.hereworksBlue500}
        />
      </Pressable>
      <View>
        {orderDropdownToggled && <ScrollView style={styles.dropdownContent}>
          {['Ascending', 'Descending'].map((item: string, index: number) => <Pressable
            style={({ hovered, pressed }: PressableState) => [
              styles.menuItem,
              hovered && Style.listItemHovered, pressed && Style.listItemPressed,
            ]}
            onPress={() => {
              setSortDescending(index === 1);
              setOrderDropdownToggled(false);
            }}
            key={`category_${index}`}
          >
            <Text style={Style.dropdownText}>{item}</Text>
          </Pressable>)}
        </ScrollView>}
      </View>
    </View>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  dropdownButton: {
    ...Style.dropdown,
    ...Style.row,
    paddingHorizontal: 12,
    paddingVertical: 9,
    marginVertical: 6,
  },
  dropdownContent: {
    ...Style.dropdown,
    flexDirection: 'column',
    alignItems: undefined,
    height: undefined,
  },
  menu: {
    marginEnd: 8,
    alignSelf: 'stretch',
  },
  menuItem: {
    paddingHorizontal: 12,
    paddingVertical: 9,
    alignSelf: 'stretch',
  },
});

export default AssetSortSelection;
